/* ==========================================================================
   AVVO — Kategorieseite (AVVO-ANPASSUNG 26, 26.09.2026), gehört zu
   sections/avvo-kollektion.liquid. Styles: assets/avvo-custom.css §9ac.

   - „Weitere Produkte laden": holt die nächste Seite als Sektion
     (?page=N&section_id=…) und hängt die Karten an, ohne Neuladen.
     Neue lieferbare Karten kommen vor die ausverkauften, damit
     Ausverkauftes auch über mehrere Seiten am Ende bleibt. Zähler
     „X von Y Produkten" und Balken rechnen mit den Karten auf der Seite.
     Ohne JS ist der Knopf ein normaler Link auf die nächste Seite.
   - „Alle N anzeigen" bei langen Filterlisten (z. B. Hersteller).
   Warehouses Kollektions-Script ersetzt beim Filtern und Sortieren den
   ganzen Produktteil; deshalb hängen alle Klicks hier am Dokument
   (delegiert) statt an einzelnen Knöpfen.
   Neue Datei, nicht von Warehouse — bei einem Theme-Update mitkopieren.
   ========================================================================== */
(function () {
  if (window.avvoKollektion) return;   // Theme-Editor lädt die Sektion neu
  window.avvoKollektion = true;

  var loadMore = function (link) {
    var section = link.closest('[data-section-type="collection"]');
    var grid = section && section.querySelector('[data-avvo-grid]');
    var wrap = link.closest('[data-avvo-more-wrap]');
    if (!grid || !wrap || link.getAttribute('aria-busy') === 'true') return;

    var url = new URL(link.getAttribute('href'), window.location.origin);
    url.searchParams.set('section_id', section.getAttribute('data-section-id'));

    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var done = function () {
      link.removeAttribute('aria-busy');
      link.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    };

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        done();
        if (!grid.isConnected) return;   // inzwischen gefiltert oder sortiert

        var temp = document.createElement('div');
        temp.innerHTML = html;
        var cards = Array.prototype.slice.call(temp.querySelectorAll('[data-avvo-grid] > .avvo-coll-card'));
        var firstSoldOut = grid.querySelector(':scope > .is-soldout');
        var firstNew = null;

        cards.forEach(function (card) {
          if (!card.classList.contains('is-soldout') && firstSoldOut) {
            grid.insertBefore(card, firstSoldOut);
          } else {
            grid.appendChild(card);
          }
          if (!firstNew) firstNew = card;
        });

        var newWrap = temp.querySelector('[data-avvo-more-wrap]');
        if (newWrap) {
          var first = newWrap.querySelector('[data-avvo-more-first]');
          if (first) first.remove();
          wrap.replaceWith(newWrap);
          wrap = newWrap;
        } else {
          wrap.remove();
          wrap = null;
        }
        if (wrap) updateCount(wrap, grid);

        // Tastatur: Fokus auf die erste neue Karte, damit man weiterlesen kann
        if (firstNew && link.getAttribute('data-avvo-keyboard') === 'true') {
          var title = firstNew.querySelector('.avvo-best__title');
          if (title) title.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        done();
        window.location.href = link.getAttribute('href');   // Notlösung: normale Seite laden
      });
  };

  var updateCount = function (wrap, grid) {
    var total = parseInt(wrap.getAttribute('data-total'), 10) || 0;
    var shown = grid.querySelectorAll(':scope > .avvo-coll-card').length;
    var text = wrap.querySelector('[data-avvo-more-text]');
    var bar = wrap.querySelector('.avvo-coll-more__bar i');
    if (text) text.textContent = shown + ' von ' + total + ' Produkten';
    if (bar && total) bar.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
  };

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-avvo-more]');
    if (more) {
      event.preventDefault();
      more.setAttribute('data-avvo-keyboard', event.detail === 0 ? 'true' : 'false');
      loadMore(more);
      return;
    }

    var values = event.target.closest('[data-avvo-more-values]');
    if (values) {
      var list = values.previousElementSibling;
      if (list) list.classList.remove('is-clipped');
      values.remove();
    }
  });
})();
